import { APIGameType, ShortGameType } from '@/types'

export type ShortMyGameZipType = [string, string, string, string | undefined]
// all next fields should be optional for smooth localstorage migration games
export function zipMyGame(game: APIGameType): ShortMyGameZipType {
    return [game.hru, game.title, game.preview, game.icon]
}
// all next fields should be optional for smooth localstorage migration games
export function unZipMyGame([hru, title, preview, icon]: ShortMyGameZipType): ShortGameType {
    return { hru, title, preview, icon }
}
